module.exports = __webpack_public_path__ + "img/alert-icon-color.dfbc0fbf.svg";